module.exports = __webpack_public_path__ + "img/spin_btn.140853e5.png";